import { TRateCardRules } from '@types';
import styles from './Rules.module.scss';
import {
	ContentExpander,
	Spacer,
	Label,
	Radio
} from '@components';
import { useRateCardRulesState } from '@hooks';
import { ChangeEvent } from 'react';

type TProps = {
	isSettings?: boolean;
	isDisabled?: boolean;
}

export const BookingPermissionsSettings = (props: TProps) => {
	const {
		isSettings = false,
		isDisabled = false,
	} = props;
	const [rateCardRules, setRateCardRules] = useRateCardRulesState();
	const rules = isSettings ? rateCardRules.settings : rateCardRules.rateCard;
	const updateRateCardRules = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		const update = {
			...rules,
			[name]: value === 'yes'
		} as TRateCardRules
		const newRules = {
			settings: isSettings ? update : undefined,
			rateCard: !isSettings ? update : undefined
		}
		setRateCardRules(newRules);
	}
	return (
		<ContentExpander
			title={<div className={styles.expanderTitle}>Booking rules</div>}
			showSpacer
			expanded={false}
			arrowsAsExpanderIcon
			iconColor='var(--neutral-06)'
		>
			<div className={styles.expanderContent}>
				<Label>Allow weekend</Label>
				<Spacer size={5} />
				<Radio.Group className={styles.row}>
					<Radio
						label={'Yes'}
						name={'allow_weekend'}
						value={'yes'}
						onChange={updateRateCardRules}
						checked={rules?.allow_weekend === true}
						disabled={isDisabled}
					/>
					<Radio
						label={'No'}
						name={'allow_weekend'}
						value={'no'}
						onChange={updateRateCardRules}
						checked={!rules?.allow_weekend}
						disabled={isDisabled}
					/>
				</Radio.Group>
				<Spacer size={10} />
				<Label>Allow change of address (within region)</Label>
				<Spacer size={5} />
				<Radio.Group className={styles.row}>
					<Radio
						label={'Yes'}
						name={'allow_address_change'}
						value={'yes'}
						onChange={updateRateCardRules}
						checked={rules?.allow_address_change === true}
						disabled={isDisabled}
					/>
					<Radio
						label={'No'}
						name={'allow_address_change'}
						value={'no'}
						onChange={updateRateCardRules}
						checked={!rules?.allow_address_change}
						disabled={isDisabled}
					/>
				</Radio.Group>
				<Spacer size={10} />
				<Label>Allow additional pick-up stops in booking</Label>
				<Spacer size={5} />
				<Radio.Group className={styles.row}>
					<Radio
						label={'Yes'}
						name={'allow_pickup_stops'}
						value={'yes'}
						onChange={updateRateCardRules}
						checked={rules?.allow_pickup_stops === true}
						disabled={isDisabled}
					/>
					<Radio
						label={'No'}
						name={'allow_pickup_stops'}
						value={'no'}
						onChange={updateRateCardRules}
						checked={!rules?.allow_pickup_stops}
						disabled={isDisabled}
					/>
				</Radio.Group>
			</div>
		</ContentExpander>
	);
}
